<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-row>
        <b-col cols="6">
          <h5>Produto</h5>
          <b-form-checkbox v-model="form.p_cp">Classe Produto</b-form-checkbox>
          <b-form-checkbox v-model="form.p_sc">Classe</b-form-checkbox>
          <b-form-checkbox v-model="form.p_tp">Tipo Produto</b-form-checkbox>
          <b-form-checkbox v-model="form.p_tm">Tipo Medida</b-form-checkbox>
        </b-col>
        <b-col cols="6">
          <h5>Subgrupo Produto</h5>
          <b-form-checkbox v-model="form.cp_gp">Grupo Produto</b-form-checkbox>
          <b-form-checkbox v-model="form.cp_dc">Definição de Contas</b-form-checkbox>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.cp_nc">N Subgrupo</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.cp_nc" v-model="form.cp_nc_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6">
          <h5>Grupo Produto</h5>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.sc_n">Número</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.sc_n" v-model="form.sc_n_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <h5>Classe Produto</h5>
          <b-form-checkbox v-model="form.sc_c">Subgrupo</b-form-checkbox>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.sc_n">Número</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.sc_n" v-model="form.sc_n_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6">
          <h5>Grupo Característica</h5>
          <b-form-checkbox v-model="form.gc_cm">Categoria Material</b-form-checkbox>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.sc_n">Número</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.sc_n" v-model="form.sc_n_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <h5>Categoria de Material</h5>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.cm_inc">INC</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.cm_inc" v-model="form.cm_inc_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-checkbox v-model="form.cm_pdm">PDM</b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center align-self-center">
                  <lg-form-input class="padding-top-ten" v-if="form.cm_pdm" v-model="form.cm_pdm_mask" placeholder="Máscara" cols="6" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-form-row class="d-flex justify-content-center mt-3">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
  name: "ConfiguracaoCamposObrigatoriosProdutoModal",
  components: {LgFormInput},
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        p_cp: false,
        p_sc: false,
        p_tp: false,
        p_tm: false,
        cp_gp: false,
        cp_dc: false,
        cp_nc: false,
        cp_nc_mask: "",
        gp_n: false,
        gp_n_mask: "",
        sc_c: false,
        sc_n: false,
        sc_n_mask: "",
        gc_cm: false,
        gc_n: false,
        gc_n_mask: "",
        cm_inc: false,
        cm_inc_mask: "",
        cm_pdm: false,
        cm_pdm_mask: "",
      },
    };
  },
  methods: {
    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const itens = this.configuracao.valorPropriedade.split(";");
        itens.forEach((item) => {
          if (item) {
            const [code, value, mask] = item.split(":");
            const booleanValue = value === "1";
            if (Object.prototype.hasOwnProperty.call(this.form, (code))) {
              this.form[code] = booleanValue;
              const maskField = code + "_mask";
              if (mask !== undefined && mask !== "") {
                if (Object.prototype.hasOwnProperty.call(this.form, (maskField))) {
                  this.form[maskField] = mask;
                }
              }
            }
          }
        });
      }
    },
    async salvar() {
      const entries = [];
      for (const key in this.form) {
        if (Object.prototype.hasOwnProperty.call(this.form, (key))&& !key.endsWith("_mask")) {
          const value = this.form[key] ? "1" : "0";
          let mask = "";
          const maskField = key + "_mask";
          if (Object.prototype.hasOwnProperty.call(this.form,(maskField)) && this.form[maskField]) {
            mask = this.form[maskField];
          }
          const entry = `${key}:${value}:${mask}`;
          entries.push(entry);
        }
      }
      const valorPropriedade = entries.join(";") + ";";

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
.mt-3 {
  margin-top: 1rem;
}
.padding-top-ten {
  padding-top: 10px;
}
</style>
